import React from 'react';
// import { FiPlus } from 'react-icons/fi';

/**
 * Posts shell header: create post control with icon + label (desktop + mobile).
 */
export default function ShellHeaderCreatePostButton({ isActive = false, onClick }) {
  return (
    <button
      type="button"
      className={`support-open-disc-shell-header-create-post-btn noOutline-text${isActive ? ' is-active' : ''}`}
      onClick={onClick}
      aria-label="Create post"
      aria-current={isActive ? 'page' : undefined}
    >
      {/* <FiPlus aria-hidden />
      <span className="support-open-disc-shell-header-create-post-btn-label">Post</span> */}
    </button>
  );
}
